import { GenericServices } from "./generic.services";
import Uri from "../common/uri/file-uri.constants";
import { ApiResponse } from "../models/app-configuration";
import { isAbsoluteUrl } from "../utils/util";

export class FileServices extends GenericServices {
  getDocumentPublishLink(fileName: string, isImage: boolean = false) {
    if (!fileName) {
      return;
    }

    // Already a (token'd) publish url — the publish-document round trip only
    // resolves relative paths (FRO-11327)
    if (isAbsoluteUrl(fileName)) {
      return Promise.resolve({ URL: fileName });
    }

    let url = Uri.getPublishDocumentLink.replace(":fileName", fileName);

    if (isImage) {
      url += "?picture=true";
    }

    return super
      .executeSelecting(undefined, url)
      .then((response: ApiResponse) => {
        return response.isSuccess
          ? Promise.resolve(response.data)
          : Promise.reject(response.message);
      })
      .catch(ex => {
        console.log(ex);
        return Promise.reject(ex);
      });
  }

  downloadDocumentsZip(module: number, id: number, documentIds?: number[]): Promise<Blob> {
    const url = Uri.downloadDocumentsZip
      .replace(":module", String(module))
      .replace(":id", String(id));
    const params = documentIds && documentIds.length
      ? { documentIds: documentIds.join(",") }
      : undefined;

    return super
      .getBlobFile(url, params)
      .then((response: ApiResponse) =>
        response.isSuccess
          ? Promise.resolve(response.data)
          : Promise.reject(response.message)
      );
  }

  getSmallPicturePublishLink(fileName: string) {
    if (!fileName) {
      return;
    }

    let url = Uri.getSmallPublishPictureLink.replace(":fileName", fileName);
    
    return super
      .executeSelecting(undefined, url)
      .then((response: ApiResponse) => {
        return response.isSuccess
          ? Promise.resolve(response.data)
          : Promise.reject(response.message);
      })
      .catch(ex => {
        console.log(ex);
        return Promise.reject(ex);
      });
  }
}
